<template>
  <v-container>
    <v-row justify="center">
      <v-col lg="10">
        <v-card>
          <v-card-title>
            <h3 class="headline">{{ $t("Support") }}</h3>
          </v-card-title>
          <validation-observer ref="form">
            <form @submit.prevent="send">
              <v-card-text>
                <v-col cols="12">
                  <validation-provider
                    v-slot="{ errors }"
                    name="name"
                    rules="required|max:255"
                  >
                    <v-text-field
                      :label="$t('Name') + ' *'"
                      v-model="name"
                      name="name"
                      outlined
                      :error-messages="errors"
                    ></v-text-field>
                  </validation-provider>
                  <validation-provider
                    v-slot="{ errors }"
                    name="email"
                    rules="required|max:255|email"
                  >
                    <v-text-field
                      name="email"
                      v-model="email"
                      :label="$t('E-mail') + ' *'"
                      outlined
                      :error-messages="errors"
                    ></v-text-field>
                  </validation-provider>
                  <validation-provider
                    v-slot="{ errors }"
                    name="phone"
                    rules="max:50"
                  >
                    <v-text-field
                      :label="$t('Phone number')"
                      v-model="phone"
                      name="phone"
                      outlined
                      :error-messages="errors"
                    ></v-text-field>
                  </validation-provider>
                  <validation-provider
                    v-slot="{ errors }"
                    name="subject"
                    rules="required|max:255"
                  >
                    <v-text-field
                      :label="$t('Subject') + ' *'"
                      v-model="subject"
                      name="subject"
                      outlined
                      :disabled="membershipBoolean"
                      :error-messages="errors"
                    ></v-text-field>
                  </validation-provider>
                  <validation-provider
                    v-slot="{ errors }"
                    name="message"
                    :rules="
                      membershipBoolean ? 'max:1000' : 'required|max:1000'
                    "
                  >
                    <v-textarea
                      :label="
                        membershipBoolean ? $t('Message') : `${$t('Message')} *`
                      "
                      v-model="message"
                      color="teal"
                      :error-messages="errors"
                      outlined
                    >
                    </v-textarea>
                  </validation-provider>

                  <v-stepper
                    v-if="membershipBoolean"
                    v-model="stepper"
                    vertical
                  >
                    <!-- <validation-provider v-slot="{errors}" name="firstStepper"> -->
                    <v-stepper-step
                      class="pt-0"
                      :rules="[() => booleanStepper1]"
                      :complete="stepper > 1"
                      step="1"
                    >
                      <span class="headline">{{
                        $t("Membership request")
                      }}</span>
                    </v-stepper-step>

                    <v-stepper-content step="1">
                      <v-card class="mb-12 mx-2 px-2">
                        <validation-provider
                          v-slot="{ errors }"
                          name="nameEntreprise"
                          rules="required|max:255"
                        >
                          <v-text-field
                            name="nameEntreprise"
                            v-model="nameEntreprise"
                            :label="`${$t('Company name')} *`"
                            :error-messages="errors"
                          ></v-text-field>
                        </validation-provider>
                        <validation-provider
                          v-slot="{ errors }"
                          name="emailAdmin"
                          rules="required|max:255"
                        >
                          <v-text-field
                            name="emailAdmin"
                            v-model="emailAdmin"
                            :label="`${$t('Admin E-mail')} *`"
                            :error-messages="errors"
                          ></v-text-field>
                        </validation-provider>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" @click="stepper = 2">{{
                            $t("Next")
                          }}</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-stepper-content>
                    <!-- </validation-provider> -->

                    <v-stepper-step
                      :rules="[() => booleanStepper2]"
                      :complete="stepper > 2"
                      step="2"
                      >{{ $t("Entity creation") }}</v-stepper-step
                    >

                    <v-stepper-content step="2">
                      <v-card class="mb-12 mx-2 px-2">
                        <validation-provider
                          v-slot="{ errors }"
                          name="nameAgence"
                          rules="required|max:255"
                        >
                          <v-text-field
                            name="nameAgence"
                            v-model="editedItem.name"
                            :label="`${$t('Name')} *`"
                            :error-messages="errors"
                          ></v-text-field>
                        </validation-provider>
                        <validation-provider
                          v-slot="{ errors }"
                          name="street1"
                          rules="required|max:255"
                        >
                          <v-text-field
                            name="street1"
                            v-model="editedItem.street1"
                            :label="`${$t('Address 1')} *`"
                            :error-messages="errors"
                          ></v-text-field>
                        </validation-provider>
                        <validation-provider
                          v-slot="{ errors }"
                          name="street2"
                          rules="max:255"
                        >
                          <v-text-field
                            name="street2"
                            v-model="editedItem.street2"
                            :label="$t('Address 2')"
                            :error-messages="errors"
                          ></v-text-field>
                        </validation-provider>
                        <validation-provider
                          v-slot="{ errors }"
                          name="street3"
                          rules="max:255"
                        >
                          <v-text-field
                            name="street3"
                            v-model="editedItem.street3"
                            :label="$t('Address 3')"
                            :error-messages="errors"
                          ></v-text-field>
                        </validation-provider>
                        <validation-provider
                          v-slot="{ errors }"
                          name="postal_code"
                          rules="required|max:255"
                        >
                          <v-text-field
                            name="postal_code"
                            v-model="editedItem.postal_code"
                            :label="`${$t('Postal code')} *`"
                            :error-messages="errors"
                          ></v-text-field>
                        </validation-provider>
                        <validation-provider
                          v-slot="{ errors }"
                          name="city"
                          rules="required|max:255"
                        >
                          <v-text-field
                            name="city"
                            v-model="editedItem.city"
                            :label="`${$t('City')} *`"
                            :error-messages="errors"
                          ></v-text-field>
                        </validation-provider>
                        <validation-provider
                          v-slot="{ errors }"
                          name="country"
                          rules="required|max:255"
                        >
                          <v-autocomplete
                            name="country"
                            v-model="editedItem.country"
                            :items="countriesList"
                            item-text="name"
                            item-value="code"
                            :label="`${$t('Country')} *`"
                            :error-messages="errors"
                          ></v-autocomplete>
                        </validation-provider>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="primary"
                            text
                            @click.stop="stepper = 1"
                            >{{ $t("Previous") }}</v-btn
                          >
                          <v-btn color="primary" @click="stepper = 3">{{
                            $t("Next")
                          }}</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-stepper-content>

                    <v-stepper-step
                      :rules="[() => booleanStepper3]"
                      :complete="stepper > 3"
                      step="3"
                      >{{ $t("Billing address") }}</v-stepper-step
                    >

                    <v-stepper-content step="3">
                      <v-card class="mb-12 mx-2 px-2">
                        <v-switch
                          v-if="this.editedId === -1"
                          v-model="switchBillingAddress"
                          :label="$t('Identical billing address')"
                          @change="autoCompleteBillingAddress()"
                        ></v-switch>

                        <validation-provider
                          v-slot="{ errors }"
                          name="billing_street1"
                          rules="required|max:255"
                        >
                          <v-text-field
                            name="billing_street1"
                            v-model="editedItem.billing_street1"
                            :label="`${$t('Address 1')} *`"
                            :error-messages="errors"
                          ></v-text-field>
                        </validation-provider>
                        <validation-provider
                          v-slot="{ errors }"
                          name="billing_street2"
                          rules="max:255"
                        >
                          <v-text-field
                            name="billing_street2"
                            v-model="editedItem.billing_street2"
                            :label="$t('Address 2')"
                            :error-messages="errors"
                          ></v-text-field>
                        </validation-provider>
                        <validation-provider
                          v-slot="{ errors }"
                          name="billing_street3"
                          rules="max:255"
                        >
                          <v-text-field
                            name="billing_street3"
                            v-model="editedItem.billing_street3"
                            :label="$t('Address 3')"
                            :error-messages="errors"
                          ></v-text-field>
                        </validation-provider>
                        <validation-provider
                          v-slot="{ errors }"
                          name="billing_postal_code"
                          rules="required|max:255"
                        >
                          <v-text-field
                            name="billing_postal_code"
                            v-model="editedItem.billing_postal_code"
                            :label="`${$t('Postal code')} *`"
                            :error-messages="errors"
                          ></v-text-field>
                        </validation-provider>
                        <validation-provider
                          v-slot="{ errors }"
                          name="billing_city"
                          rules="required|max:255"
                        >
                          <v-text-field
                            name="billing_city"
                            v-model="editedItem.billing_city"
                            :label="`${$t('City')} *`"
                            :error-messages="errors"
                          ></v-text-field>
                        </validation-provider>
                        <validation-provider
                          v-slot="{ errors }"
                          name="billing_country"
                          rules="required|max:255"
                        >
                          <v-autocomplete
                            name="billing_country"
                            v-model="editedItem.billing_country"
                            :items="countriesList"
                            item-text="name"
                            item-value="code"
                            :label="`${$t('Country')} *`"
                            :error-messages="errors"
                          ></v-autocomplete>
                        </validation-provider>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="primary"
                            text
                            @click.stop="stepper = 2"
                            >{{ $t("Previous") }}</v-btn
                          >
                          <v-btn color="primary" @click="stepper = 4">{{
                            $t("Next")
                          }}</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-stepper-content>
                    <v-stepper-step
                      :rules="[() => booleanStepper4]"
                      :complete="stepper > 4"
                      step="4"
                      >{{ $t("Company information") }}</v-stepper-step
                    >
                    <v-stepper-content step="4">
                      <v-card class="mb-12 mx-2 px-2">
                        <validation-provider
                          v-if="isFrenchTerritory"
                          v-slot="{ errors }"
                          name="siret"
                          rules="required|numeric|length:14"
                        >
                          <v-text-field
                            name="siret"
                            v-model="editedItem.siret"
                            label="SIRET *"
                            :error-messages="errors"
                          ></v-text-field>
                        </validation-provider>
                        <validation-provider
                          v-if="countriesEuropean"
                          v-slot="{ errors }"
                          name="vat"
                          rules="required"
                        >
                          <v-text-field
                            name="vat"
                            v-model="editedItem.vat"
                            :label="`${$t('V.A.T.')} *`"
                            :error-messages="errors"
                            hint="FR12345678907"
                          ></v-text-field>
                        </validation-provider>
                        <validation-provider
                          v-if="!countriesEuropean"
                          v-slot="{ errors }"
                          name="fiscal_number_reference"
                          rules="required|max:50"
                        >
                          <v-text-field
                            name="fiscal_number_reference"
                            v-model="editedItem.fiscal_number_reference"
                            :label="`${$t('Fiscal number reference')} *`"
                            :error-messages="errors"
                          ></v-text-field>
                        </validation-provider>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="primary"
                            text
                            @click.stop="stepper = 3"
                            >{{ $t("Previous") }}</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                    </v-stepper-content>
                  </v-stepper>
                </v-col>
                <p>{{ $t("* Required fields") }}</p>
              </v-card-text>
              <v-card-actions style="margin-left: 50px">
                <v-switch
                  class="ml-5"
                  v-if="$store.state.auth.loggedIn == false"
                  v-model="membershipBoolean"
                  @change="
                    stepper = 1;
                    membershipBooleanFunction();
                  "
                  :label="$t('Membership request')"
                  style="transform: scale(1.5)"
                ></v-switch>
                <v-spacer></v-spacer>
                <v-btn :loading="loading" color="success" type="submit">{{
                  $t("Send")
                }}</v-btn>
              </v-card-actions>
              <v-snackbar light v-model="loading" centered :timeout="-1">
                <lottie-animation
                  :path="`${publicPath}animations/sending-email.json`"
                  :autoPlay="true"
                  :loop="true"
                  :speed="1.5"
                  :height="150"
                  :width="150"
                ></lottie-animation>
              </v-snackbar>
              <v-snackbar light v-model="sentEmail" centered :timeout="4000">
                <lottie-animation
                  :path="`${publicPath}animations/email-sent.json`"
                  :autoPlay="true"
                  :loop="true"
                  :height="150"
                  :width="150"
                ></lottie-animation>
              </v-snackbar>
              <v-snackbar light v-model="errorSending" centered :timeout="4000">
                <lottie-animation
                  :path="`${publicPath}animations/error-sending.json`"
                  :autoPlay="true"
                  :loop="true"
                  :height="150"
                  :width="150"
                ></lottie-animation>
              </v-snackbar>
              <vue-recaptcha
                ref="recaptcha"
                :sitekey="sitekey"
                size="invisible"
                :loadRecaptchaScript="true"
                @verify="onVerify"
              ></vue-recaptcha>
            </form>
          </validation-observer>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import snackbar from "@/mixins/snackbar";
import LottieAnimation from "lottie-vuejs/src/LottieAnimation";
import { mapState } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import countries from "i18n-iso-countries";

export default {
  name: "Support",
  components: {
    ValidationObserver,
    ValidationProvider,
    VueRecaptcha,
    LottieAnimation,
  },
  mixins: [snackbar],

  data() {
    return {
      sitekey: process.env.VUE_APP_RECAPTCHA_SITEKEY,
      loading: false,
      name: this.$store.state.auth.user?.name,
      email: this.$store.state.auth.user?.email,
      phone: "",
      subject: "",
      message: "",
      membershipBoolean: false,
      countries: countries.getNames(this.$i18n.locale),
      stepper: 1,
      switchBillingAddress: false,
      nameEntreprise: "",
      emailAdmin: "",
      publicPath: process.env.BASE_URL.substring(1),
      sentEmail: false,
      errorSending: false,
    };
  },
  watch: {
    membershipBoolean(value) {
      if (value) {
        this.subject = this.$t("Membership request");
      } else {
        this.subject = null;
        this.$refs.form.reset();
      }
    },
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    ...mapState("entities", ["editedId"]),
    editedItem: {
      get() {
        return this.$store.state.entities.editedItem;
      },
      set(value) {
        this.$store.commit("entities/setEditedItem", value);
      },
    },

    countriesList() {
      return Object.keys(this.countries).reduce((acc, x) => {
        acc.push({ code: x, name: this.countries[x] });
        return acc;
      }, []);
    },

    countriesEuropean() {
      return countries.isCountryCodeInEU(this.editedItem.country);
    },

    booleanStepper1() {
      let boolStep1 = true;
      if (
        !(
          this.$refs.form.errors.nameEntreprise == 0 &&
          this.$refs.form.errors.emailAdmin == 0
        )
      ) {
        boolStep1 = false;
      }
      return boolStep1;
    },

    booleanStepper2() {
      let boolStep2 = true;
      if (
        !(
          this.$refs.form.errors.nameAgence == 0 &&
          this.$refs.form.errors.street1 == 0 &&
          this.$refs.form.errors.postal_code == 0 &&
          this.$refs.form.errors.city == 0 &&
          this.$refs.form.errors.country == 0
        )
      ) {
        boolStep2 = false;
      }
      return boolStep2;
    },

    booleanStepper3() {
      let boolStep3 = true;
      if (
        !(
          this.$refs.form.errors.billing_street1 == 0 &&
          this.$refs.form.errors.billing_postal_code == 0 &&
          this.$refs.form.errors.billing_city == 0 &&
          this.$refs.form.errors.billing_country == 0
        )
      ) {
        boolStep3 = false;
      }
      return boolStep3;
    },

    booleanStepper4() {
      let boolStep4 = true;
      if (!this.countriesEuropean) {
        if (this.$refs.form.errors.fiscal_number_reference != 0) {
          boolStep4 = false;
        }
      } else if (this.isFrenchTerritory) {
        if (
          !(
            this.$refs.form.errors.siret == 0 && this.$refs.form.errors.vat == 0
          )
        ) {
          boolStep4 = false;
        }
      } else {
        if (!(this.$refs.form.errors.vat == 0)) {
          boolStep4 = false;
        }
      }
      return boolStep4;
    },

    isFrenchTerritory() {
      return countries.isFrenchTerritory(this.editedItem.billing_country);
    },
  },
  created() {
    if (this.$route.query.membership == 1) {
      this.$nextTick(() => {
        this.membershipBoolean = true;
      });
    }
  },
  methods: {
    onVerify(response) {
      this.loading = true;
      const data = {
        name: this.name,
        email: this.email,
        phone: this.phone,
        subject: this.subject,
        message: this.message,
        topicId: 19,
        nameEntreprise: this.nameEntreprise,
        emailAdmin: this.emailAdmin,
        membershipBoolean: this.membershipBoolean,
        nameAgence: this.editedItem.name,
        street1: this.editedItem.street1,
        street2: this.editedItem.street2,
        street3: this.editedItem.street3,
        postal_code: this.editedItem.postal_code,
        city: this.editedItem.city,
        country: this.editedItem.country,
        billing_street1: this.editedItem.billing_street1,
        billing_street2: this.editedItem.billing_street2,
        billing_street3: this.editedItem.billing_street3,
        billing_postal_code: this.editedItem.billing_postal_code,
        billing_city: this.editedItem.billing_city,
        billing_country: this.editedItem.billing_country,
        siret: this.editedItem.siret,
        vat: this.editedItem.vat,
        fiscal_number_reference: this.editedItem.fiscal_number_reference,
        "g-recaptcha-response": response,
      };
      this.axios
        .post("/api/support", data)
        .then(() => {
          this.$refs.form.reset();
          this.loading = false;
          this.sentEmail = true;
          this.snackbar("success", this.$t("snackbar-message.successSupport"));
          this.membershipBoolean = false;
          this.resetFirstForm();
        })
        .catch(this.responseError);
    },
    send() {
      this.$refs.form.validate().then((success) => {
        if (!success) {
          return;
        }
        this.$refs.recaptcha.execute();
      });
    },
    responseError(error) {
      this.loading = false;
      this.errorSending = true;
      if (error.response && error.response.status === 422) {
        let errors = error.response.data.errors;
        this.$refs.form.setErrors(errors);
      } else {
        this.snackbar("error", this.$t("snackbar-message.errorSupport"));
      }
    },

    autoCompleteBillingAddress() {
      if (this.switchBillingAddress) {
        this.editedItem.billing_street1 = this.editedItem.street1;
        this.editedItem.billing_street2 = this.editedItem.street2;
        this.editedItem.billing_street3 = this.editedItem.street3;
        this.editedItem.billing_postal_code = this.editedItem.postal_code;
        this.editedItem.billing_city = this.editedItem.city;
        this.editedItem.billing_country = this.editedItem.country;
      } else if (this.editedId === -1) {
        this.editedItem.billing_street1 = null;
        this.editedItem.billing_street2 = null;
        this.editedItem.billing_street3 = null;
        this.editedItem.billing_postal_code = null;
        this.editedItem.billing_city = null;
        this.editedItem.billing_country = null;
      }
    },
    membershipBooleanFunction() {
      (this.nameEntreprise = null),
        (this.emailAdmin = null),
        (this.editedItem.name = null);
      this.editedItem.street1 = null;
      this.editedItem.street2 = null;
      this.editedItem.street3 = null;
      this.editedItem.postal_code = null;
      this.editedItem.city = null;
      this.editedItem.country = null;
      this.editedItem.billing_street1 = null;
      this.editedItem.billing_street2 = null;
      this.editedItem.billing_street3 = null;
      this.editedItem.billing_postal_code = null;
      this.editedItem.billing_city = null;
      this.editedItem.billing_country = null;
      this.editedItem.siret = null;
      this.editedItem.vat = null;
      this.editedItem.fiscal_number_reference = null;
    },
    resetFirstForm() {
      this.name = null;
      this.email = null;
      this.phone = null;
      this.subject = null;
      this.message = null;
    },
  },
};
</script>

<style>
.grecaptcha-badge {
  z-index: 999;
}
</style>